'use strict';

let codes = Object.freeze({
    IMAGE_NOT_FOUND                              : 'spawnService.imageNotFound',
    IMAGE_NOT_AVAILABLE                          : 'spawnService.imageNotAvailable',
    IMAGE_ALREADY_EXISTS                         : 'spawnService.imageAlreadyExists',
    VENDOR_NOT_FOUND                             : 'spawnService.vendorNotFound',
    VENDOR_ALREADY_EXISTS                        : 'spawnService.vendorAlreadyExists',
    LOCATION_NOT_FOUND                           : 'spawnService.locationNotFound',
    LOCATION_NOT_AVAILABLE                       : 'spawnService.locationNotAvailable',
    LOCATION_ALREADY_EXISTS                      : 'spawnService.locationAlreadyExists',
    SERVER_NOT_FOUND                             : 'spawnService.serverNotFound',
    NOT_FOUND                                    : 'spawnService.notFound',
    SPAWN_FAILED                                 : 'spawnService.spawnFailed',
    BAD_CONFIG                                   : 'spawnService.configurationBadOrMissing',
    OPERATION_FAILED                             : 'spawnService.operationFailed',
    SERVER_WITH_SAME_IDENTIFIER_ALREADY_REQUESTED: 'spawnService.serverWithSameIdentifierAlreadyRequested',
    SERVER_ALREADY_STOPPED                       : 'spawnService.serverAlreadyStopped',
    SERVERS_LIMIT_REACHED                        : 'spawnService.serversLimitReached'
});

module.exports = codes;
